<template>
  <div class="step-two">
    <div class="nav">
      <p
        class="nav-item"
        :class="{ active: activeNav == item.id }"
        v-for="item in navList"
        :key="item.id"
        @click="handleClick(item.id, '.section-' + item.id)"
      >
        {{ item.label }}
      </p>
    </div>

    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      size="small"
      class="form"
      label-width="170px"
    >
      <div class="title section-1">店铺基本信息</div>
      <el-form-item label="店铺ID">
        <p>2788809482449671</p>
      </el-form-item>
      <el-form-item label="店铺类型" prop="shopType">
        <el-radio-group
          v-model="form.shopType"
          @click.native="handleTips('shopType')"
        >
          <el-radio label="1">
            <el-tooltip placement="right" effect="light">
              <div slot="content">
                <p class="tool-tip">普通店:</p>
                <p class="tool-tip">1.适合无品牌的商家；</p>
                <p class="tool-tip">2.店铺功能和其它类型店铺无差别；</p>
                <p class="tool-tip">
                  3.完成入驻后可补充品牌信息修改为其它店铺类型。
                </p>
              </div>
              <span>普通店</span>
            </el-tooltip>
          </el-radio>
          <el-radio label="2">
            <el-tooltip placement="right" effect="light">
              <div slot="content">
                <p class="tool-tip">专营店:</p>
                <p class="tool-tip">
                  1.需保证有1个类目下至少包含2个品牌（支持授权品牌或自有品牌），其他类目1个及以上品牌均可（支持授权品牌或自有品牌）；
                </p>
                <p class="tool-tip">2.自有品牌：商标为R标或TM标均可；</p>
                <p class="tool-tip">3.授权品牌：商标为R标才可以进行授权；</p>
                <p class="tool-tip">
                  4.完成入驻后仅可修改为旗舰店，不支持修改为其他店铺类型。
                </p>
              </div>
              <span>专营店</span>
            </el-tooltip>
          </el-radio>
          <el-radio label="3">
            <el-tooltip placement="right" effect="light">
              <div slot="content">
                <p class="tool-tip">专卖店:</p>
                <p class="tool-tip">
                  1.可经营1个或多个授权品牌，多个授权品牌需属于同一商标所有人；
                </p>
                <p class="tool-tip">2.授权品牌：商标为R标才可以进行授权；</p>
                <p class="tool-tip">
                  3.完成入驻后仅可修改为旗舰店，不支持修改为其他店铺类型。
                </p>
              </div>
              <span>专卖店</span>
            </el-tooltip>
          </el-radio>
          <el-radio label="4">
            <el-tooltip placement="right" effect="light">
              <div slot="content">
                <p class="tool-tip">旗舰店:</p>
                <p class="tool-tip">1.可经营1个或多个自有品牌；</p>
                <p class="tool-tip">
                  2.可经营1个或多个一级独占授权品牌，多个授权品牌需属于同一商标所有人；
                </p>
                <p class="tool-tip">3.自有品牌：商标为R标或TM标均可；</p>
                <p class="tool-tip">4.授权品牌：商标为R标才可以进行授权；</p>
                <p class="tool-tip">5.完成入驻后不支持修改为其他店铺类型。</p>
              </div>
              <span>旗舰店</span>
            </el-tooltip>
          </el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="旗舰店品牌归属"
        prop="qjAscription"
        v-show="form.shopType == '4'"
      >
        <el-radio-group
          v-model="form.qjAscription"
          @click.native="handleTips('qjAscription')"
        >
          <el-radio label="自有品牌">自有品牌</el-radio>
          <el-radio label="授权品牌">授权品牌</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="店铺名称" prop="shopName">
        <div v-if="form.shopType == '1'">
          <el-input
            v-model="form.shopName"
            placeholder="店铺名称"
            @click.native="handleTips('PTshop')"
            style="display: inline-block; width: 70%"
          ></el-input>
          <a
            href="https://school.jinritemai.com/doudian/web/article/101821?from=shop_article"
            target="_blank"
            rel="noopener noreferrer"
            class="link"
            >查看店铺命名规则</a
          >
          <div class="preview-name" v-if="form.shopName">
            店铺名预览：{{ form.shopName }}
          </div>
        </div>
        <div v-else-if="form.shopType == '2'" style="position: relative">
          <el-input
            v-model="form.shopName"
            placeholder="请输入企业商号"
            @click.native="handleTips('ZYshop')"
            style="display: inline-block; margin-right: 8px; width: 43%"
          ></el-input>
          <el-input
            v-model="form.shopCategory"
            placeholder="请选择或填写类目名"
            @click.native="handleTips('ZYshop')"
            style="display: inline-block; margin-right: 8px; width: 43%"
            @focus="showCategory = true"
            @blur="handleBlur"
          ></el-input>
          <span>专营店</span>
          <div class="categorys" v-show="showCategory">
            <span
              v-for="item in categoryList"
              :key="item"
              @click="form.shopCategory = item"
              >{{ item }}</span
            >
          </div>
          <div class="preview-name" v-if="form.shopName || form.shopCategory">
            店铺名预览：{{ form.shopName }}{{ form.shopCategory }}专营店
          </div>
        </div>
        <div v-else-if="form.shopType == '3'">
          <el-input
            v-model="form.shopName"
            placeholder="请输入品牌名"
            @click.native="handleTips('ZMshop')"
            style="display: inline-block; margin-right: 8px; width: 43%"
          ></el-input>
          <el-input
            v-model="form.firm"
            placeholder="请输入企业商号（选填）"
            @click.native="handleTips('ZMshop')"
            style="display: inline-block; margin-right: 8px; width: 43%"
          ></el-input>
          <span>专卖店</span>
          <div class="preview-name" v-if="form.shopName">
            店铺名预览：{{ form.shopName }}{{ form.firm }}专卖店
          </div>
        </div>
        <div v-else style="position: relative">
          <el-input
            v-model="form.shopName"
            placeholder="请输入品牌名"
            @click.native="handleTips('QJshop')"
            style="display: inline-block; margin-right: 8px; width: 37%"
          ></el-input>
          <el-input
            v-model="form.shopCategory"
            placeholder="请选择或填写类目名（选填）"
            @click.native="handleTips('QJshop')"
            style="display: inline-block; margin-right: 8px; width: 37%"
            @focus="showCategory = true"
            @blur="handleBlur"
          ></el-input>
          <el-select
            v-model="form.qjType"
            placeholder="请选择"
            style="display: inline-block; width: 22%"
          >
            <el-option label="旗舰店" value="旗舰店"> </el-option>
            <el-option label="官方旗舰店" value="官方旗舰店"> </el-option>
          </el-select>
          <div class="categorys" v-show="showCategory">
            <span
              v-for="item in categoryList"
              :key="item"
              @click="form.shopCategory = item"
              >{{ item }}</span
            >
          </div>
          <div class="preview-name" v-if="form.shopName || form.shopCategory">
            店铺名预览：{{ form.shopName }}{{ form.shopCategory
            }}{{ form.qjType }}
          </div>
        </div>
      </el-form-item>
      <el-form-item label="店铺logo" prop="logo">
        <el-upload
          class="uploader"
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="(file) => upload(file, 'logo')"
          @click.native="handleTips('logo')"
        >
          <el-image
            class="upload_img"
            v-if="form.logo"
            :src="form.logo"
            fit="cover"
          ></el-image>
          <div class="pl" v-else>
            <i class="el-icon-plus"></i>
            <p class="upload-tips">上传图片</p>
          </div>
        </el-upload>
      </el-form-item>
      <el-form-item label="肖像授权书" prop="portrait">
        <div
          v-for="(item, idx) in form.portrait"
          :key="item"
          class="upload-list"
        >
          <el-image
            class="upload-list-img"
            :src="item"
            fit="cover"
            :preview-src-list="form.portrait"
          ></el-image>
          <div class="del-btn">
            <i
              class="el-icon-delete"
              @click="handleDelPortrait('portrait', idx)"
            ></i>
          </div>
        </div>
        <el-upload
          class="uploader"
          action="#"
          :show-file-list="false"
          :auto-upload="false"
          :on-change="(file) => upload(file, 'portrait', true, 10)"
          @click.native="handleTips('portrait')"
        >
          <div class="pl">
            <i class="el-icon-plus"></i>
            <p class="upload-tips">({{ form.portrait.length }}/10)</p>
          </div>
        </el-upload>
        <div class="download-btn">
          <i class="el-icon-download"></i
          ><a
            href="https://school.jinritemai.com/doudian/web/article/112579?from=shop_settled"
            target="_blank"
            rel="noopener noreferrer"
            >下载肖像版权</a
          >
        </div>
      </el-form-item>
      <el-form-item label="肖像授权书有效期" prop="portraitDate">
        <el-date-picker
          v-model="form.portraitDate"
          type="date"
          placeholder="请选择"
          :disabled="portraitDateLong"
          @click.native="handleTips('portraitDate')"
        >
        </el-date-picker>
        <el-checkbox v-model="portraitDateLong" style="margin-left: 10px"
          >长期</el-checkbox
        >
      </el-form-item>

      <div class="line"></div>

      <div class="title section-2">经营类目</div>
      <el-form-item label="经营类目" prop="category">
        <el-cascader
          v-model="form.category"
          :options="options"
          :props="{ multiple: true, value: 'label' }"
          clearable
          @click.native="handleTips('category')"
        ></el-cascader>
        <a
          href="https://school.jinritemai.com/doudian/web/article/110363?from=shop_article"
          target="_blank"
          rel="noopener noreferrer"
          class="link"
          >查看类目说明</a
        >
        <p class="c-tips">
          必须从营业执照允许的经营范围内选择，否则无法审核通过
        </p>
      </el-form-item>

      <div class="line"></div>

      <template
        v-if="
          form.shopType == '2' || form.shopType == '3' || form.shopType == '4'
        "
      >
        <div class="title section">品牌资质</div>
        <p class="c-tips" style="margin-top: -16px; margin-bottom: 24px">
          当前店铺类型：
          <span v-if="form.shopType == '2'">专营店</span>
          <span v-else-if="form.shopType == '3'">专卖店</span>
          <span v-else-if="form.shopType == '4'">旗舰店</span>
          ，可选品牌数：1-5个，若开店成功，后续可增加更多品牌
        </p>
        <div class="brand" v-for="(item, idx) in form.brand" :key="idx">
          <p style="margin-left: 100px; margin-bottom: 24px">
            品牌资质{{ idx + 1 }}
            <el-popconfirm
              title="删除当前品牌资质？"
              @confirm="handleDelBrand(idx)"
            >
              <el-button
                slot="reference"
                type="text"
                v-if="idx > 0"
                style="margin-left: 5px; padding: 0"
                >删除</el-button
              >
            </el-popconfirm>
          </p>
          <el-form-item
            label="所属类目"
            :prop="'brand.' + idx + '.category'"
            :rules="[
              { required: true, message: '请选择所属类目', trigger: 'blur' },
            ]"
          >
            <el-cascader
              v-model="item.category"
              :options="options"
              :props="{ multiple: true }"
              clearable
              placeholder="请在商标注册范围内选择一个或多个类目"
              @click.native="handleTips('brandCategory')"
              style="width: 100%"
            ></el-cascader>
          </el-form-item>
          <el-form-item
            label="商标注册号"
            :prop="'brand.' + idx + '.trademarkingNumber'"
            :rules="[
              { required: true, message: '请输入商标注册号', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="item.trademarkingNumber"
              placeholder="请与商标注册证及商标注册官网查询保持一致"
              @click.native="handleTips('trademarkingNumber')"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="品牌中文名"
            :prop="'brand.' + idx + '.chineseBrand'"
            :rules="[
              {
                validator: (rule, value, callback) =>
                  validateName(rule, value, callback, idx),
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="item.chineseBrand"
              placeholder="请正确填写标准品牌中文名"
              @click.native="handleTips('chineseBrand')"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="品牌英文名"
            :prop="'brand.' + idx + '.englishBrand'"
            :rules="[
              {
                validator: (rule, value, callback) =>
                  validateName(rule, value, callback, idx),
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="item.englishBrand"
              placeholder="请与商标注册证及商标注册官网查询保持一致"
              @click.native="handleTips('englishBrand')"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="商标注册人"
            :prop="'brand.' + idx + '.registrant'"
            :rules="[
              { required: true, message: '请填写商标注册人', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="item.registrant"
              placeholder="请与商标注册证及商标注册官网查询保持一致"
              @click.native="handleTips('registrant')"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="品牌经营类型"
            :prop="'brand.' + idx + '.brandType'"
            :rules="[
              {
                required: true,
                message: '请选择品牌经营类型',
                trigger: 'blur',
              },
            ]"
            @click.native="handleTips('brandType')"
          >
            <div v-if="form.shopType == '4'">
              <p>
                {{
                  form.qjAscription == "自有品牌" ? "自有品牌" : "一级代理品牌"
                }}
              </p>
              <p style="font-size: 12px; color: #aaabaf; line-height: 16px">
                {{
                  form.qjAscription == "自有品牌"
                    ? "开店主体商标注册人"
                    : "开店主体非商标注册人，需提供由商标权利人直接授权"
                }}
              </p>
            </div>
            <el-radio-group v-model="item.brandType" v-else>
              <el-radio label="自有品牌" v-if="form.shopType == '2'"
                >自有品牌</el-radio
              >
              <el-radio label="授权品牌">授权品牌</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            label="商标注册有效期"
            :prop="'brand.' + idx + '.trademarkingDate'"
            :rules="[
              {
                required: true,
                message: '请选择商标注册有效期',
                trigger: 'blur',
              },
            ]"
          >
            <el-date-picker
              v-model="item.trademarkingDate"
              type="date"
              placeholder="请与商标注册证及商标注册官网查询保持一致"
              :disabled="item.trademarkingDateLong"
              @click.native="handleTips('trademarkingDate')"
            ></el-date-picker>
            <el-checkbox
              v-model="item.trademarkingDateLong"
              style="margin-left: 10px"
              @change="(val) => handleLongChange(val, idx)"
              >长期</el-checkbox
            >
          </el-form-item>
          <el-form-item
            label="商标注册证"
            :prop="'brand.' + idx + '.certificate'"
            :rules="[
              {
                required: true,
                message: '请上传商标注册证',
                trigger: 'blur',
              },
            ]"
          >
            <div
              v-for="(c, i) in item.certificate"
              :key="i"
              class="upload-list"
            >
              <el-image
                class="upload-list-img"
                :src="c"
                fit="cover"
                :preview-src-list="item.certificate"
              ></el-image>
              <div class="del-btn">
                <i
                  class="el-icon-delete"
                  @click="handleDelCertificate('certificate', idx, i)"
                ></i>
              </div>
            </div>
            <el-upload
              class="uploader"
              action="#"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="
                (file) => handleUpload(file, 'certificate', true, 20, idx)
              "
              @click.native="handleTips('certificate')"
            >
              <div class="pl">
                <i class="el-icon-plus"></i>
                <p class="upload-tips">({{ item.certificate.length }}/20)</p>
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item
            label="品牌授权链路"
            v-if="
              item.brandType == '授权品牌' ||
              (form.shopType == '4' && form.qjAscription == '授权品牌')
            "
            @click.native="handleTips('authorizationLink')"
          >
            <div>
              <span class="dot active"></span>
              <span
                >品牌方授权给{{
                  item.authorizationLink.haveAgent ? "代理经销商" : "开店主体"
                }}</span
              >
              <div
                class="box"
                :class="{
                  active: item.authorizationLink.haveAgent,
                  noborder: form.shopType == '4',
                }"
              >
                <div
                  v-for="(coa, n) in item.authorizationLink.coa"
                  :key="n"
                  class="upload-list"
                >
                  <el-image
                    class="upload-list-img"
                    :src="coa"
                    fit="cover"
                    :preview-src-list="item.authorizationLink.coa"
                  ></el-image>
                  <div class="del-btn">
                    <i
                      class="el-icon-delete"
                      @click="
                        handleDelCertificate('authorizationLink', idx, n, 'coa')
                      "
                    ></i>
                  </div>
                </div>
                <el-upload
                  class="uploader"
                  action="#"
                  :show-file-list="false"
                  :auto-upload="false"
                  :on-change="
                    (file) =>
                      handleUpload(
                        file,
                        'authorizationLink',
                        true,
                        20,
                        idx,
                        'coa'
                      )
                  "
                >
                  <div class="pl">
                    <i class="el-icon-plus"></i>
                    <p class="upload-tips">
                      ({{ item.authorizationLink.coa.length }}/20)
                    </p>
                  </div>
                </el-upload>
                <div class="download-btn">
                  <i class="el-icon-download"></i
                  ><a
                    href="https://school.jinritemai.com/doudian/web/article/107498?from=shop_settled"
                    target="_blank"
                    rel="noopener noreferrer"
                    >下载授权书模板</a
                  >
                </div>

                <p>授权书有效期</p>
                <el-date-picker
                  class="s"
                  v-model="item.authorizationLink.coaDate"
                  type="date"
                  placeholder="请与授权书中有效期保持一致"
                  :disabled="item.coaDateLong"
                ></el-date-picker>
                <el-checkbox
                  v-model="item.coaDateLong"
                  style="margin-left: 10px"
                  >长期</el-checkbox
                >
              </div>
              <div v-show="form.shopType == '2' || form.shopType == '3'">
                <span
                  class="dot"
                  :class="{ active: item.authorizationLink.haveAgent }"
                ></span>
                <el-button
                  v-if="!item.authorizationLink.haveAgent"
                  type="text"
                  icon="el-icon-plus"
                  style="color: #1966ff"
                  @click="item.authorizationLink.haveAgent = true"
                  >添加代理经销商授权</el-button
                >
                <template v-else>
                  <span>代理经销商授权给开店主体</span>
                  <el-button
                    type="text"
                    icon="el-icon-delete"
                    style="margin-left: 200px; color: #898b8f"
                    @click="item.authorizationLink.haveAgent = false"
                    >删除</el-button
                  >
                </template>
                <div
                  v-show="item.authorizationLink.haveAgent"
                  style="padding-left: 16px; padding-bottom: 30px"
                >
                  <div
                    v-for="(coa, n) in item.authorizationLink.agentCoa"
                    :key="n"
                    class="upload-list"
                  >
                    <el-image
                      class="upload-list-img"
                      :src="coa"
                      fit="cover"
                      :preview-src-list="item.authorizationLink.agentCoa"
                    ></el-image>
                    <div class="del-btn">
                      <i
                        class="el-icon-delete"
                        @click="
                          handleDelCertificate(
                            'authorizationLink',
                            idx,
                            n,
                            'agentCoa'
                          )
                        "
                      ></i>
                    </div>
                  </div>
                  <el-upload
                    class="uploader"
                    action="#"
                    :show-file-list="false"
                    :auto-upload="false"
                    :on-change="
                      (file) =>
                        handleUpload(
                          file,
                          'authorizationLink',
                          true,
                          20,
                          idx,
                          'agentCoa'
                        )
                    "
                  >
                    <div class="pl">
                      <i class="el-icon-plus"></i>
                      <p class="upload-tips">
                        ({{ item.authorizationLink.agentCoa.length }}/20)
                      </p>
                    </div>
                  </el-upload>
                  <div class="download-btn">
                    <i class="el-icon-download"></i
                    ><a
                      href="https://school.jinritemai.com/doudian/web/article/107498?from=shop_settled"
                      target="_blank"
                      rel="noopener noreferrer"
                      >下载授权书模板</a
                    >
                  </div>

                  <p>授权书有效期</p>
                  <el-date-picker
                    class="s"
                    v-model="item.authorizationLink.agentCoaDate"
                    type="date"
                    placeholder="请与授权书中有效期保持一致"
                    :disabled="item.agentCoaDateLong"
                  ></el-date-picker>
                  <el-checkbox
                    v-model="item.agentCoaDateLong"
                    style="margin-left: 10px"
                    >长期</el-checkbox
                  >
                </div>
              </div>
            </div>
          </el-form-item>
        </div>
        <div
          class="addBtn"
          v-show="form.brand.length < 5"
          @click="handleAddBrand"
        >
          <i class="el-icon-plus"></i>
          <span>添加品牌资质</span>
        </div>
        <div class="line"></div>
      </template>

      <div class="title section-3">管理人信息</div>
      <el-form-item label="管理人姓名" prop="administrator">
        <el-input
          v-model="form.administrator"
          maxlength="25"
          show-word-limit
          placeholder="请输入管理人姓名"
          @click.native="handleTips('administrator')"
        ></el-input>
      </el-form-item>
      <el-form-item label="管理人手机号" prop="administratorMobile">
        <el-input
          v-model="form.administratorMobile"
          maxlength="11"
          show-word-limit
          placeholder="请输入管理人手机号"
          @click.native="handleTips('administratorMobile')"
        ></el-input>
        <p class="c-tips">此手机号作为唯一用于订单下载和资金结算，请慎重填写</p>
      </el-form-item>

      <div class="line"></div>

      <div class="agreement">
        <el-checkbox v-model="form.agree">我已仔细阅读并同意</el-checkbox>
        <span
          class="agreement-text"
          @click="
            handleCheck(
              '《电子商务开放平台店铺服务协议（2022版）》',
              'https://lf3-cm.ecombdstatic.com/obj/ecom-ecop/16409395342e74ad8be919d58ec09e906da1846784f6323fea.pdf'
            )
          "
          >《电子商务开放平台店铺服务协议（2022版）》</span
        >
        <span
          class="agreement-text"
          @click="
            handleCheck(
              '《抖音电商外部合作方廉洁合规政策》',
              'https://lf3-cm.ecombdstatic.com/obj/ecom-ecop/1640939846c0d51bd26d9bfba37d8718874e93a2fb162320eb.pdf'
            )
          "
          >《抖音电商外部合作方廉洁合规政策》</span
        >
      </div>
    </el-form>

    <el-dialog
      :title="agreementTitle"
      :visible.sync="show"
      width="630px"
      :close-on-click-modal="false"
    >
      <object :data="agreementLink" type="application/pdf" class="pdf-area">
        <iframe
          :src="agreementLink"
          width="100%"
          height="100%"
          style="border: none"
        >
          浏览器不支持PDF预览，请先下载PDF:
          <a :href="agreementLink">下载 PDF</a>
        </iframe>
      </object>
    </el-dialog>
  </div>
</template>

<script>
import upload from "@/utils/uploadMethod";
import category from "@/utils/category.js";
export default {
  data() {
    var checkShopName = (rule, value, callback) => {
      if (this.form.shopType == "1") {
        if (!this.form.shopName) {
          return callback(new Error("店铺名称不能为空"));
        } else {
          callback();
        }
      } else if (this.form.shopType == "2") {
        if (!this.form.shopName) {
          return callback(new Error("企业商号不能为空"));
        } else if (!this.form.shopCategory) {
          callback(new Error("类目名不能为空"));
        } else {
          callback();
        }
      } else {
        if (!this.form.shopName) {
          return callback(new Error("品牌名不能为空"));
        } else {
          callback();
        }
      }
    };
    var validateName = (rule, value, callback, idx) => {
      if (
        !this.form.brand[idx].chineseBrand &&
        !this.form.brand[idx].englishBrand
      ) {
        callback(new Error("品牌中文名和英文名至少输入一项"));
      } else {
        callback();
      }
    };
    return {
      activeNav: 1,
      navList: [
        { id: 1, label: "店铺基本信息" },
        { id: 2, label: "经营类目" },
        { id: 3, label: "管理人信息" },
      ],
      form: {
        shopType: "1",
        shopName: "",
        logo: "",
        portrait: [],
        portraitDate: "",
        category: "",
        administrator: "",
        administratorMobile: "",
        shopCategory: "",
        qjType: "旗舰店",
        firm: "",
        qjAscription: "自有品牌",
        brand: [
          {
            category: "",
            trademarkingNumber: "",
            chineseBrand: "",
            englishBrand: "",
            registrant: "",
            brandType: "自有品牌",
            trademarkingDate: "",
            trademarkingDateLong: false,
            certificate: [],
            authorizationLink: {
              coa: [],
              coaDate: "",
              coaDateLong: false,
              haveAgent: false,
              agentCoa: [],
              agentCoaDate: "",
              agentCoaDateLong: false,
            },
          },
        ],
        agree: false
      },
      portraitDateLong: false,
      rules: {
        shopType: {
          required: true,
          message: "请选择店铺类型",
          trigger: "blur",
        },
        shopName: [
          {
            validator: checkShopName,
            trigger: "blur",
          },
          {
            required: true,
            message: "店铺名称不能为空",
            trigger: "blur",
          },
        ],
        qjAscription: {
          required: true,
          message: "请选择旗舰店品牌归属",
          trigger: "blur",
        },
        logo: {
          required: true,
          message: "请上传店铺logo",
          trigger: "blur",
        },
        category: {
          required: true,
          message: "请选择经营类目",
          trigger: "blur",
        },
        administrator: {
          required: true,
          message: "请输入管理人姓名",
          trigger: "blur",
        },
        administratorMobile: {
          required: true,
          message: "请输入管理人手机号",
          trigger: "blur",
        },
      },
      validateName,
      options: category.options,
      agreementTitle: "",
      agreementLink: "",
      show: false,
      showCategory: false,
      categoryList: [
        "美妆",
        "食品",
        "饮品",
        "肉类",
        "生鲜",
        "水果",
        "服饰",
        "箱包",
        "鞋靴",
        "珠宝",
        "文具",
        "玩具",
        "家具",
        "家居",
        "家电",
        "个人护理",
        "清洁用品",
        "3C数码",
        "手机",
        "旅游",
        "票务",
        "母婴用品",
        "图书",
        "二手商品",
        "鲜花",
        "绿植",
        "酒水",
        "滋补品",
      ],
    };
  },
  watch: {
    "form.shopType"(val) {
      this.form.brand.length = 1;
      if (val == 3) {
        this.form.brand[0].brandType = "授权品牌";
      } else if (val == 4) {
        this.form.brand[0].brandType = this.form.qjAscription;
      }
    },
    portraitDateLong(val) {
      if (val) {
        this.form.portraitDate = "长期";
      } else {
        this.form.portraitDate = "";
      }
    },
  },
  methods: {
    //上传图片
    async upload(file, str, isMultiple, limit) {
      const fileUrl = await upload(file);
      if (isMultiple) {
        if (this.form[str].length >= limit) {
          this.$message.warning(`最多上传${limit}张`);
          return;
        }
        this.form[str].push(fileUrl);
      } else this.form[str] = fileUrl;
    },
    async handleUpload(file, str, isMultiple, limit, idx, deepStr) {
      const fileUrl = await upload(file);
      let arr;
      if (deepStr) arr = this.form.brand[idx][str][deepStr];
      else arr = this.form.brand[idx][str];
      if (isMultiple) {
        if (arr.length >= limit) {
          this.$message.warning(`最多上传${limit}张`);
          return;
        }
        arr.push(fileUrl);
      } else arr = fileUrl;
    },
    // 删除图片
    handleDelPortrait(str, idx) {
      this.form[str].splice(idx, 1);
    },
    handleDelCertificate(str, index, idx, deepStr) {
      if (deepStr) {
        this.form.brand[index][str][deepStr].splice(idx, 1);
      } else {
        this.form.brand[index][str].splice(idx, 1);
      }
    },
    // 锚点跳转
    handleClick(id, selector) {
      console.log(selector);
      this.activeNav = id;
      this.$el.querySelector(selector).scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    },
    // 同步右侧提示
    handleTips(formItem) {
      this.$emit("onTips", formItem);
    },
    // 查看底部协议政策
    handleCheck(str, link) {
      this.agreementTitle = str;
      this.agreementLink = link;
      this.show = true;
    },
    handleBlur() {
      setTimeout(() => {
        this.showCategory = false;
      }, 200);
    },
    // 添加品牌资质
    handleAddBrand() {
      let brandType;
      if (this.form.shopType == "2") {
        brandType = "自有品牌";
      } else if (this.form.shopType == "4") {
        brandType = this.form.qjAscription;
      } else {
        brandType = "授权品牌";
      }
      this.form.brand.push({
        category: "",
        trademarkingNumber: "",
        chineseBrand: "",
        englishBrand: "",
        registrant: "",
        brandType,
        trademarkingDate: "",
        certificate: [],
        authorizationLink: {
          coa: [],
          coaDate: "",
          coaDateLong: false,
          haveAgent: false,
          agentCoa: [],
          agentCoaDate: "",
          agentCoaDateLong: false,
        },
      });
    },
    // 删除品牌资质
    handleDelBrand(idx) {
      this.form.brand.splice(idx, 1);
    },
    handleLongChange(isLong, idx) {
      this.form.brand[idx].trademarkingDate = isLong ? "长期" : "";
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.agree) this.$emit("onSuccess", this.form);
          else this.$message.warning("请先勾选协议");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.step-two {
  position: relative;
  text-align: left;
  .nav {
    position: sticky;
    top: 0;
    margin-left: -24px;
    background: #fff;
    z-index: 999;
    .nav-item {
      position: relative;
      display: inline-block;
      padding: 16px 24px;
      font-size: 16px;
      line-height: 22px;
      color: #55585c;
      cursor: pointer;
      &:hover {
        color: #1966ff;
      }
      &.active {
        color: #1966ff;
        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 96px;
          height: 3px;
          border-radius: 1.5px;
          background: #1966ff;
        }
      }
    }
  }
  ::v-deep .form {
    .title {
      margin: 24px 0;
      font-weight: 500;
      font-size: 16px;
      line-height: 22px;
      color: #12141a;
    }
    .el-form-item {
      margin-bottom: 24px;
    }
    .el-form-item__content {
      width: 530px;
    }
    .el-radio {
      display: block;
      padding: 7px 0;
      .el-radio__input.is-checked .el-radio__inner {
        border-color: #1966ff;
        background: #1966ff;
      }
      .el-radio__input.is-checked + .el-radio__label {
        color: inherit;
      }
    }

    .el-checkbox {
      .el-checkbox__input.is-checked .el-checkbox__inner {
        border-color: #1966ff;
        background: #1966ff;
      }
      .el-checkbox__input.is-checked + .el-checkbox__label {
        color: inherit;
      }
    }
    .link {
      margin-left: 8px;
      color: #1966ff;
      &:hover {
        text-decoration: underline;
      }
    }
    .upload-list {
      position: relative;
      display: inline-block;
      margin-right: 8px;
      width: 88px;
      height: 88px;
      &:hover {
        .del-btn {
          opacity: 1;
        }
      }
      .del-btn {
        opacity: 0;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 88px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.6);
        transition: all 0.3s ease;
        .el-icon-delete {
          cursor: pointer;
        }
      }
    }
    .upload-list-img {
      width: 100%;
      height: 100%;
    }
    .uploader {
      position: relative;
      display: inline-block;
      width: 88px;
      height: 88px;
      border: 1px dashed #dcdde0;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;
      vertical-align: top;
      &:hover {
        border-color: #3388ff;
        .pl {
          color: #3388ff;
        }
      }

      .pl {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 100%;
        color: #85878a;
        transform: translate(-50%, -50%);
        .el-icon-plus {
          font-size: 16px;
        }
        .upload-tips {
          font-size: 12px;
        }
      }

      .upload_img {
        width: 88px;
        height: 88px;
        display: block;
      }
    }

    .download-btn {
      color: #1966ff;
      cursor: pointer;
      font-size: 12px;
    }

    .el-date-editor {
      width: 85%;
      &.s {
        width: 84.5%;
      }
    }

    .line {
      width: 100%;
      height: 1px;
      background-color: #edeef0;
    }
    .el-cascader {
      width: 78%;
    }

    .c-tips {
      margin: 4px 0 0;
      font-size: 12px;
      line-height: 16px;
      color: #85878a;
      white-space: nowrap;
    }

    .agreement {
      padding: 25px 0;
      text-align: center;
    }
    .agreement-text {
      color: #1966ff;
      cursor: pointer;
    }

    .categorys {
      position: absolute;
      top: 38px;
      left: 205px;
      width: 460px;
      background: #fff;
      border: 1px solid #edeef0;
      box-shadow: 0px 4px 16px rgb(37 41 49 / 8%);
      border-radius: 4px;
      padding: 8px 12px 8px;
      z-index: 99;
      span {
        display: inline-block;
        width: 25%;
        height: 34px;
        line-height: 34px;
        color: #252931;
        padding-top: 6px;
        padding-bottom: 6px;
        padding-left: 12px;
        vertical-align: top;
        cursor: pointer;
        &:hover {
          color: #1966ff;
        }
      }
    }

    .preview-name {
      display: inline-block;
      margin-top: 4px;
      color: rgb(85, 88, 92);
      border: 1px solid transparent;
      background-color: rgb(243, 244, 246);
      margin: 4px 8px 0px 0px;
      padding: 4px 8px;
      border-radius: 2px;
      font-size: 12px;
      line-height: 14px;
      font-weight: 400;
    }

    .dot {
      display: inline-block;
      margin-left: -4px;
      margin-right: 10px;
      width: 10px;
      height: 10px;
      background-color: rgba(0, 0, 0, 0.25);
      border-radius: 50%;
      &.active {
        background-color: #1890ff;
      }
    }
    .box {
      padding-left: 16px;
      padding-bottom: 30px;
      border-left: solid 1px #f0f0f0;
      &.active {
        border-left-color: #1890ff;
      }
      &.noborder {
        border: none;
      }
    }
    .addBtn {
      margin-left: 170px;
      margin-bottom: 24px;
      display: inline-block;
      padding: 6px 16px;
      color: #1966ff;
      background: #fff;
      border: 1px solid #1966ff;
      border-radius: 4px;
      line-height: 18px;
      cursor: pointer;
      i {
        font-weight: bold;
        margin-right: 3px;
      }
      &:hover {
        i,
        span {
          opacity: 0.9;
        }
      }
    }
  }

  .pdf-area {
    width: 100%;
    height: 472px;
  }
  ::v-deep .el-dialog {
    .el-dialog__header {
      background-color: #f3f4f6;
      padding: 14px 24px;
      .el-dialog__title {
        font-size: 14px;
        line-height: 20px;
        color: #12141a;
      }
    }
  }
}
</style>
<style lang="less">
.tool-tip {
  line-height: 22px;
  max-width: 240px;
}
</style>